import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate hook
import { getSubGallery } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle" 
const SubGallery = () => {
  const homeMenu = [ 
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    { label: "Gallery", link: "/Gallery", subMenu: [{ label: "Photo Gallery", link: "/Gallery" }, { label: "Video Gallery", link: "/VideoGallery" },] },

    { label: "Careers", link: "/careers-openings", subMenu: [
        { label: "Philosophy", link: "/philosophy" }, 
    ]},
    { label: "School Calendar", link: "/calender" },
    {
        label: "Alumni", link: "", subMenu: [
            { label: "Admissions", link: "/admission" },
           { label: "Admissions IIT", link: "/admissionIIT" },
        ]
    },

    { label: "eMagazine", link: "/magazine" },
    { label: "CUET", link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/CUET.pdf" },
]
        
    const navigate = useNavigate();
    const location = useLocation();
    const id = new URLSearchParams(location.search).get("id");
    const [data, setData] = useState("");
    const [index, setIndex] = React.useState(-1);
  
    console.log(id);
  
    useEffect(() => {
     const getData = async () => {
       try {
         let subgalleryData = await getSubGallery(id);
         console.log(subgalleryData);
         setData(subgalleryData);
       } catch (error) {
         console.log(error);
       }
     };
     getData();
   }, [id]); // Add id as a dependency
   
  
    console.log(data);
  
    const slides = data?.attachments?.map(img => ({
      src: `https://webapi.entab.info/api/image/${img}`
    }));
  return (
    <> 
   <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-vision.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
        <div className="row">
            <div className="col-md-12">
              <PageTitle pageTitle={data.title} breadEnd="Gallery" breadMid={data.title} />
            </div>
          </div>
       <div className="row">
          <div className="col-md-12">    
             <div className="fulwidth">
                 
                <div className="discription">
                
                  
                </div>
             </div>
            
             <div className="flexbox-v zoompic row">
             {data && data.attachments && data.attachments.length > 0 && (
  data.attachments.map((img, index) => (
    <div key={index} className="col-lg-3">
      
      <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href={`https://webapi.entab.info/api/image/${img}`}>
        <LazyLoad><img  src={`https://webapi.entab.info/api/image/${img}`} onClick={() => setIndex(index)} className="img-fluid" alt={`Image ${index}`} /></LazyLoad>
      </a>
    </div>
  ))
)}

                {/* <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                     <SlideshowLightbox><LazyLoad><img  src="https://webapi.entab.info/api/image/LCSD/public/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div> */}
             </div> 
          </div>
       </div>
    </div>
    </div>
    <Footer />
   </>
  )
}

export default SubGallery
